import { createUseStyles } from "react-jss";

interface VerticalDividerProps {
  height?: string;
  width?: string;
  color?: string;
  marginRight?: string;
  marginLeft?: string;
}

const useStyles = createUseStyles({
  verticalDivider: (props: VerticalDividerProps) => ({
    width: props.width || "1px",
    height: props.height || "28px",
    backgroundColor: props.color || "var(--border-color)",
    marginRight: props.marginRight || "11px",
    marginLeft: props.marginLeft || "1px",
    alignSelf: "center",
    position: "relative",
    verticalAlign: "middle",
    display: "inline-block",
  }),
});

const VerticalDivider: React.FC<VerticalDividerProps> = (props) => {
  const classes = useStyles(props);

  return <div className={classes.verticalDivider} />;
};

export default VerticalDivider;
